import { color } from '../../GlobalStyles';
import { extendSemantics } from '@veneer/semantics';
import { ThemeProvider } from '@veneer/theme';

const theme = extendSemantics({
  color: {
    light: {
      foreground: {
        disabled: color.white,
      },
      background: {
        disabled: color.gray5,
      },
      primary: {
        base: {
          default: color.gray12,
          hover: color.gray12,
          active: color.gray12,
        },
        background: {
          default: 'rgba(163,163,163,0.2)',
          hover: 'rgba(163,163,163,0.2)',
          active: 'rgba(163,163,163,0.2)',
        },
      },
      neutral: {
        base: {
          default: color.gray3,
        },
        background: {
          hover: 'rgba(163,163,163,0.1)',
        },
      },
      focus: {
        default: 'rgba(163,163,163,0)',
        inverse: 'rgba(163,163,163,0)',
      },
    },
  },
});

export default function ThemeProviderWrapper({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <ThemeProvider shape="sharp" mode="light" customSemantics={theme}>
      {children}
    </ThemeProvider>
  );
}
